/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'loop': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M32.102 2.2l-14.5 14.5h-.3v.3L14.2 20.102l3.101 3.101v.301h.301l14.5 14.602 4.8-4.8L27 23.601h52.802c4.101 0 7.5 3.398 7.5 7.5v28.602h6.8V31.102c0-7.898-6.398-14.3-14.3-14.3H27.198L37 6.898zM63.199 66.602l9.8 9.8-52.8-.003c-4.102 0-7.5-3.399-7.5-7.5V40.3H5.898v28.602c0 7.898 6.398 14.3 14.301 14.3L73 83.2 63.2 93l4.8 4.802L82.602 83.2h.3L82.9 83 86 79.9 82.9 76.797v-.3h-.3l-14.7-14.599z"/>'
  }
})
